import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import TopoSemMenu from '../../components/TopoSemMenu';
import Termo from './components/Termo';

class TermosServico extends React.Component {
  render() {
    return (
      <div>
        <TopoSemMenu/>

        <Switch>
          <Route path="/:token" component={ () => <Termo /> } />
        </Switch>
      </div>
    );
  }
}

export default withRouter(TermosServico);
